import client from "./client";

export const assembliesApi = {
  list: (projectId) => client.get(`/assemblies/project/${projectId}`),
  create: (projectId, data) => client.post(`/assemblies/project/${projectId}`, data),
  get: (id) => client.get(`/assemblies/${id}`),
  update: (id, data) => client.put(`/assemblies/${id}`, data),
  delete: (id) => client.delete(`/assemblies/${id}`),

  addMember: (assemblyId, data) => client.post(`/assemblies/${assemblyId}/members`, data),
  updateMember: (assemblyId, memberId, data) =>
    client.patch(`/assemblies/${assemblyId}/members/${memberId}`, data),
  removeMember: (assemblyId, memberId) =>
    client.delete(`/assemblies/${assemblyId}/members/${memberId}`),

  addHQPoints: (assemblyId, points) =>
    client.post(`/assemblies/${assemblyId}/hq`, points),
  clearHQ: (assemblyId) => client.delete(`/assemblies/${assemblyId}/hq`),
};

export const libraryApi = {
  list: () => client.get("/library"),
  copyDesign: (designId, projectId, name) =>
    client.post(`/library/${designId}/copy`, { project_id: projectId, name }),
  publish: (designId) => client.patch(`/library/${designId}/publish`),
};

